import React, { useState } from 'react';
import { FiLogOut, FiChevronLeft } from 'react-icons/fi';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';

// ACCA-style instructions overlay, closely matching the provided screenshot
// Props:
// - exam: object with title or other labels
// - onNext: function called when user presses Next
// - onExit: function called when user presses Exit
const ShowInstructions = ({ exam = {}, onNext, onExit }) => {
  // Completely prevent rendering of this component
  React.useEffect(() => {
    console.log('🎯 ShowInstructions component rendered - preventing render');
    if (onExit) onExit();
  }, [onExit]);
  
  // Return null to prevent any rendering
  return null;
};

export default ShowInstructions;
